<!--
  과정 아이템 컴포넌트
  - 호출 페이지
    - 과정 목록 컴포넌트 (CompMmpCourseList.vue)
-->
<template>
  <div
    :class="['course_item', listClass, deviceType]"
  >
    <div class="inner">
      <!-- 과정 기본정보 -->
      <div :style="corsCd ? 'cursor:pointer' : ''" class="wrap_course_cont">
        <!-- 썸네일 -->
        <div class="wrap_thumbnail">
          <img
            :src="courseItem.thumbPc"
            :alt="courseItem.title"
            class="thumb_img"
            @error="loadFallbackImage"
          >
        </div>
        <!-- // 썸네일 -->

        <!-- spec area -->
        <div class="wrap_spec">
          <!-- 라벨 -->
          <div v-if="showLabel === 'Y'" class="wrap_label">
            <ul>
              <!-- loop -->
              <li v-for="(labelItem, labelIndex) in courseItem.label" :key="labelIndex">
                <span class="txt">{{ labelItem }}</span>
              </li>
            </ul>
          </div>
          <!-- // 라벨 -->

          <!-- 타이틀 -->
          <div v-if="showHtmlTitle" class="wrap_title">
            <!-- <p v-if="mode === 'search'" class="tit"><em>ChatGPT와 랭체인(LangCahin)</em>을 활용한 LLM 이해</p> &lt;!&ndash; <em> 태그로 검색어 하이라이팅 &ndash;&gt;-->
            <!-- <p v-else class="tit">{{ courseItem.title }}</p>-->
            <p class="tit">{{ courseItem.title }}</p>
          </div>
          <!-- // 타이틀 -->

          <!-- 날짜 -->
          <div v-if="showDate" class="wrap_date" style="height: 25px">
            <ul>
              <li v-for="(scheduleItem, scheduleIndex) in courseItem.schedule" :key="scheduleIndex">
                <span class="txt">{{ scheduleItem }}</span>
              </li>
            </ul>
          </div>
          <!-- // 날짜 -->

        </div>
        <!-- // spec area -->

        <!-- 가변 레이아웃 영역 -->
        <div class="wrap_span_area">
          <div class="span_inner" style="height: 26px">
            <!-- 평점, 리뷰 -->
            <ul v-if="shouldShowReview" class="wrap_review">
              <!-- 평점 -->
              <li v-if="isValid(courseItem.rating)" class="rating">
                <span class="txt">{{ courseItem.rating }}</span>
              </li>
              <!-- // 평점 -->

              <!-- 리뷰 -->
              <li v-if="isValid(courseItem.review)" class="review">
                <span class="txt">{{ courseItem.review }}</span>
              </li>
              <!-- // 리뷰 -->
            </ul>
            <!-- // 평점, 리뷰 -->

            <!-- 태그 -->
            <div v-if="shouldShowTag" class="wrap_tag">
              <ul>
                <li
                  v-for="(tagItem, tagIndex) in courseItem.tag"
                  v-if="isValid(tagItem)" :key="tagIndex"
                >
                  <span class="txt">{{ tagItem }}</span>
                </li>
              </ul>
            </div>
            <!-- // 태그 -->
          </div>
        </div>
        <!-- // 가변 레이아웃 영역 -->

      </div>
      <!-- // 과정 기본정보 -->

      <!-- 과정 부가정보(아이템 푸터 영역) -->
      <div v-if="showFooter" class="wrap_course_footer">
        <!-- 찜 등록일 -->
        <div v-if="listItemClass === 'choice_list_item'" class="choice_reg_date">
          <span class="txt">찜 등록일 2024.04.17</span>
        </div>
        <!-- // 찜 등록일 -->

        <!-- 가격 -->
        <div v-else class="wrap_price">
          <span class="price">1,050,000<em>원</em></span>
        </div>
        <!-- // 가격 -->

        <!-- 버튼 -->
        <ComCorsButtonGroup
          :item="courseItem"
          :list-type="listType"
        />
        <!-- // 버튼 -->
      </div>
      <!-- // 과정 부가정보(아이템 푸터 영역) -->
    </div>
  </div>
</template>

<script>
import ComCorsButtonGroup from '~pages/nrw/common/ComCorsButtonGroup'

export default {
  name: 'CompCourseItem',
  components: {
    ComCorsButtonGroup
  },
  props: {
    crtnTyp: {
      type: String,
      default: 'BAS'
    },
    maxSetupNum: {
      type: Number,
      default: null
    },
    courseItem: {
      type: Object,
      default: null
    },
    corsCd: { // 상세 페이지 이동을 위한 CD
      type: String,
      default: ''
    },
    gallerySize: {
      type: String,
      default: 'medium'
    },
    listType: { // 리스트형, 갤러리형 구분
      type: String,
      default: 'list'
    },
    listTypeMo: { // 모바일에서 리스트 타입이 PC와 다른 경우 적용
      type: String,
      default: ''
    },
    showTitle: { // 타이틀 영역 노출 여부
      type: Boolean,
      default: false
    },
    showHtmlTitle: { // 타이틀 영역 노출 여부
      type: Boolean,
      default: false
    },
    showReview: { // 별점, 리뷰 영역 노출 여부
      type: Boolean,
      default: true
    },
    // 날짜 영역 노출 여부
    showDate: {
      type: Boolean,
      default: true
    },
    showLabel: {
      type: String,
      default: ''
    },
    showTag: { // 아이템 태그 영역 노출 여부
      type: Boolean,
      default: true
    },
    showSchedule: { // 날짜 영역 노출 여부
      type: Boolean,
      default: true
    },
    showFooter: { // 아이템 푸터 영역 노출 여부
      type: Boolean,
      default: false
    },
    thumbLinkUrl: { // 썸네일
      type: String,
      default: ''
    },
    title: { // 타이틀
      type: String,
      default: ''
    },
    corsLabelList: { // 라벨 리스트
      type: Array,
      default: () => []
    },
    scheduleDateList: { // 수강 날짜
      type: Array,
      default: () => []
    },
    rating: { // 평점
      type: Number,
      default: null
    },
    reviewCnt: { // 리뷰수
      type: Number,
      default: null
    },
    tagList: { // 태그 리스트
      type: Array,
      default: () => []
    },
    price: { // 가격
      type: Number,
      default: null
    }
  },
  data () {
    return {
      listClass: this.listType, // 리스트 형태별 클래스
      fallbackImageUrl: require('@/assets/images/common/noimage.jpg') // 과정 이미지 오류 시 노출되는 기본 이미지 URL
    }
  },
  computed: {
    deviceType () { // 화면 사이즈 기분 디바이스 타입 구분 (pc, tablet, mobile)
      return window.vue.getStore('homeInfo').state.deviceType
    },
    isDesktop () {
      return window.vue.getStore('homeInfo').state.isDeskTopMode
    },
    shouldShowReview () {
      const isReviewVisible = this.showReview && (this.isValid(this.courseItem.rating) || this.isValid(this.courseItem.review))
      const isTabType = this.crtnTyp === 'TAB'
      const isGallery = this.listType === 'gallery'
      const isMobileWithFewSetup = !this.isDesktop && !isTabType && isGallery && this.maxSetupNum < 4

      // 데스크탑 화면, Tab형은 평점/리뷰 노출
      // 모바일이고 maxSetupNum이 4 미만일 때는 평점/리뷰 노출
      return isReviewVisible && (this.isDesktop || isTabType || isMobileWithFewSetup)
    },
    shouldShowTag () {
      const isTagVisible = this.showTag
      const isTabType = this.crtnTyp === 'TAB'
      const isGallery = this.listType === 'gallery'
      const isMobileWithDifferentSetup = !this.isDesktop && !isTabType && (isGallery || this.maxSetupNum !== 3)

      // 데스크탑 화면, Tab형은 태그 노출
      // 모바일이고 maxSetupNum이 3이 아니면, 태그 노출
      return isTagVisible && (this.isDesktop || isTabType || isMobileWithDifferentSetup)
    }
  },
  watch: {
    'listType': {
      handler: function (nVal, oVal) {
        if (nVal !== oVal) {
          this.listClass = this.listType
        }
      }
    }
  },
  methods: {
    isValid (value) {
      return value !== null && value !== ''
    },
    // 과정 상세로 이동
    openDetail () {
      console.log('openDetail')
      if (!this.corsCd) return
      this.$goPage({name: 'CrsDetail', query: {corsCd: this.corsCd}})
    },
    // 과정 이미지 에러 발생시 기본 이미지로 교체
    loadFallbackImage (e) {
      const imgEl = e.target
      imgEl.src = this.fallbackImageUrl
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/nrw/portlet/CompCourseItem.vue